<template>
  <div class="table-wrapper" id="office-table">
    <div class="dekstop-table">
      <b-row class="table-header">
        <div>Дата регистрации кода</div>

        <div>Код</div>

        <div>Статус</div>

        <div>Наименование приза</div>
      </b-row>

      <div class="table">
        <div v-if="!receipts">
          <h3>НЕТ ДАННЫХ</h3>
        </div>

        <div class="" v-if="receipts" v-for="(receipt, index) in receipts">
          <b-row class="table-line">
            <div class="flex-center">{{ receipt.created_at }}</div>

            <div class="flex-center">{{ receipt.code }}</div>

            <div class="flex-center">
              {{
                receipt.status.i18n
              }}
            </div>

            <div class="position-relative flex-center">
              <span v-for="prize in receipt.prizes"
                    style="max-width: 70%; display: inline-block;"
                    v-if="!!prize.name">
                {{ prize.name }}
              </span>


              <!-- <span v-if="(receipt.prizes !== null && receipt.prizes.length > 0)">
                {{ receipt.prizes }}
              </span> -->

              <div class="plus-wrapper" @click="toggleSubTable(index)" v-if="receipt.status.slug != 'failed'">
                <img src="@/assets/svg/plus.svg"
                     class="icon plus active-icon" />

                <img src="@/assets/svg/minus.svg"
                     class="icon minus" />
              </div>
            </div>
          </b-row>

          <div class="hidden green-subtable" :id="index" v-if="receipt.status.slug != 'failed'">
            <b-row class="table-header table-header__green">
              <div>Дата</div>

              <div>Код</div>

              <div>Статус</div>

              <div>Приз</div>
            </b-row>

            <b-row class="table-line table-line__green" v-for="prize in receipt.prizes">
              <div>{{ receipt.created_at }}</div>

              <div>{{ receipt.code }}</div>

              <div class="period-wrapper">
                {{
                  prize.period.i18n
                }}

                <div class="period-hint" v-if="prize.period.slug === 'weekly' || prize.period.slug === 'monthly'">
                  <img src="@/assets/svg/tooltip.svg"
                       class="tooltip"
                       @click="openPrizesModal(prize.period.slug)" />
                </div>
              </div>

              <div class="position-relative prize-name-wrapper">
                {{
                  !!!prize.name
                      ? prize.status.i18n
                      : prize.name
                }}

                <img v-if="!!prize.props && prize.slug === 'garant_prize_digital'"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openBookModal(index)"
                />

                <img v-if="!!prize.props && prize.slug === 'garant_prize_ivi'"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openIviModal(index)"
                />

                <img v-if="!!prize.props && (prize.slug !== 'garant_prize_ivi' && prize.slug !== 'garant_prize_digital')"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openCommonModal(index)"
                />

                    <b-modal
                      :id="'ivi-modal'+index"
                      ref="modal"
                      v-if="!!prize.props && prize.slug === 'garant_prize_ivi'"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('ivi-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Промокод на подписку<br> иви на 45 дней<br><br>
                        </h3>

                        <div class="ivi-code">
                          {{ prize.props }}
                        </div>

                        <div class="ivi-text">
                          Условии активации промокодов на Подписку Иви:<br>
                          А. Промокод можно активировать до 31.03.2027 включительно,
                          только на территории РФ<br>
                          Б. Промокод можно активировать только в случае, если у
                          Участника нет действующей либо истекшей в предыдущие
                          90 дней подписки на сервисе Иви, а также если он не участвовал
                          в других акциях в отношении подписки на сервисе Иви в предыдущие 180 дней.
                          <br>
                          В. Для активации промокода необходимо указать данные банковской карты,
                          которую ранее не указывали на Сервисе Иви. Для проверки карты может
                          быть удержана и возвращена сумма в лимитах, предусмотренных
                          Пользовательским соглашением. <br>
                          Г. Услуга «Подписка Иви» предоставляется на условиях автопродления.
                          После окончания предоставления услуги по промокоду,
                          Подписка Иви продлевается на условиях раздела 13
                          Пользовательского соглашения на следующие 30 дней по стоимости,
                          которая будет действовать на момент автопродления.
                          Участник в любой момент может отказаться от продления услуги
                          Подписка Иви на условиях Пользовательского соглашения. <br>
                          Д. Подписка по промокоду становится недоступной немедленно после
                          отключения автоматического продления Подписки Иви в учетной записи
                          Участника на сервисе Иви.Е.Активируя промокод, Участник подтверждает
                          свое согласие с Пользовательским соглашением сервиса
                          Иви
                          <a href="https://www.ivi.ru/info/agreement" target="_blank">
                            https://www.ivi.ru/info/agreement
                          </a>.
                        </div>
                      </div>
                    </b-modal>

                    <b-modal
                      :id="'book-modal'+index"
                      v-if="!!prize.props && prize.slug === 'garant_prize_digital'"
                      ref="modal"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('book-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Буклет с рецептами <br> для гриля <br><br><br>
                        </h3>

                        <a class="button-modal" variant="primary" :href="prize.props">
                          Скачать
                        </a>
                      </div>
                    </b-modal>

                    <b-modal
                      :id="'cert-modal'+index"
                      v-if="!!prize.props && (prize.slug !== 'garant_prize_ivi' && prize.slug !== 'garant_prize_digital')"
                      ref="modal"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('cert-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Ваш подарочный <br>сертификат <br><br><br>
                        </h3>

                        <a class="button-modal" variant="primary" :href="prize.props">
                          Скачать
                        </a>
                      </div>
                    </b-modal>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-table">
      <b-row class="table-header">
        <div>
          Дата загрузки <br />
          Код / <br />
          Статус кода
        </div>

        <div>Приз</div>
      </b-row>

      <div class="table">
        <div v-if="!receipts">
          <h3>НЕТ ДАННЫХ</h3>
        </div>

        <div v-if="receipts" v-for="(receipt, index) in receipts">
          <b-row class="table-line">
            <div>
              {{ receipt.created_at }} <br />
              {{ receipt.code }} <br />

              {{
                receipt.status.i18n
              }}
            </div>

            <div style="position: relative" class="flex-center">
              <span v-for="(prize, index) in receipt.prizes"
                    style="max-width: 70%; display: inline-block;"
                    v-if="!!prize.name">
                {{ prize.name }}
              </span>

              <div class="plus-wrapper" @click="toggleSubTable(`mobile`+index)" v-if="receipt.status.slug != 'failed'">
                  <img src="@/assets/svg/plus.svg"
                      class="icon plus active-icon" />

                  <img src="@/assets/svg/minus.svg"
                      class="icon minus" />
                </div>
            </div>
          </b-row>

          <div class="hidden green-subtable" :id="`mobile`+index" v-if="receipt.status.slug != 'failed'">
            <b-row class="table-header table-header__green">
              <div>
                Дата <br>
                Код / <br>
                Статус
              </div>

              <div>Приз</div>
            </b-row>

            <b-row class="table-line table-line__green" v-for="prize in receipt.prizes">
              <div style="position: relative;">
                {{ receipt.created_at }} <br>
                {{ receipt.code }} <br>
                {{
                  prize.period.i18n
                }}

                <div class="period-hint" v-if="prize.period.slug === 'weekly' || prize.period.slug === 'monthly'">
                  <img src="@/assets/svg/tooltip.svg"
                       class="tooltip"
                       @click="openPrizesModal(prize.period.slug)" />
                </div>
              </div>

              <div class="position-relative center-j">
                {{
                  !!!prize.name
                      ? prize.status.i18n
                      : prize.name
                }}

                <img v-if="!!prize.props && prize.slug === 'garant_prize_digital'"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openBookModal(index)"
                />

                <img v-if="!!prize.props && prize.slug === 'garant_prize_ivi'"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openIviModal(index)"
                />

                <img v-if="!!prize.props && (prize.slug !== 'garant_prize_ivi' && prize.slug !== 'garant_prize_digital')"
                     src="@/assets/svg/download.svg"
                     class="download-icon"
                     @click="openCommonModal(index)"
                />

                    <b-modal
                      :id="'ivi-modal'+index"
                      ref="modal"
                      v-if="!!prize.props && prize.slug === 'garant_prize_ivi'"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('ivi-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Промокод на подписку<br> иви на 45 дней<br><br>
                        </h3>

                        <div class="ivi-code">
                          {{ prize.props }}
                        </div>

                        <div class="ivi-text">
                          Условии активации промокодов на Подписку Иви:<br>
                          А. Промокод можно активировать до 31.03.2027 включительно,
                          только на территории РФ<br>
                          Б. Промокод можно активировать только в случае, если у
                          Участника нет действующей либо истекшей в предыдущие
                          90 дней подписки на сервисе Иви, а также если он не участвовал
                          в других акциях в отношении подписки на сервисе Иви в предыдущие 180 дней.
                          <br>
                          В. Для активации промокода необходимо указать данные банковской карты,
                          которую ранее не указывали на Сервисе Иви. Для проверки карты может
                          быть удержана и возвращена сумма в лимитах, предусмотренных
                          Пользовательским соглашением. <br>
                          Г. Услуга «Подписка Иви» предоставляется на условиях автопродления.
                          После окончания предоставления услуги по промокоду,
                          Подписка Иви продлевается на условиях раздела 13
                          Пользовательского соглашения на следующие 30 дней по стоимости,
                          которая будет действовать на момент автопродления.
                          Участник в любой момент может отказаться от продления услуги
                          Подписка Иви на условиях Пользовательского соглашения. <br>
                          Д. Подписка по промокоду становится недоступной немедленно после
                          отключения автоматического продления Подписки Иви в учетной записи
                          Участника на сервисе Иви.Е.Активируя промокод, Участник подтверждает
                          свое согласие с Пользовательским соглашением сервиса
                          Иви
                          <a href="https://www.ivi.ru/info/agreement" target="_blank">
                            https://www.ivi.ru/info/agreement
                          </a>.
                        </div>
                      </div>
                    </b-modal>

                    <b-modal
                      :id="'cert-modal'+index"
                      v-if="!!prize.props && (prize.slug !== 'garant_prize_ivi' && prize.slug !== 'garant_prize_digital')"
                      ref="modal"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('cert-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Ваш подарочный <br>сертификат <br><br><br>
                        </h3>

                        <a class="button-modal" variant="primary" :href="prize.props">
                          Скачать
                        </a>
                      </div>
                    </b-modal>

                    <b-modal
                      :id="'book-modal'+index"
                      v-if="!!prize.props && prize.slug === 'garant_prize_digital'"
                      ref="modal"
                      title=""
                      hide-footer
                      hide-header
                      centered
                    >
                      <div class="header">
                        <span class="close-icon"
                              @click="$bvModal.hide('book-modal'+index)">
                          <img src="@/assets/svg/close.svg"
                              aria-label="close">
                        </span>

                        <h3>
                          Буклет с рецептами <br> для гриля <br><br><br>
                        </h3>

                        <a class="button-modal" variant="primary" :href="prize.props">
                          Скачать
                        </a>
                      </div>
                    </b-modal>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <Pagination :pages="pagination"
                @page-change="pageChange" />
  </div>
</template>

<script>
import axios from "axios";
import Pagination from '@/components/Pagination.vue'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "OfficeTable",

  components: {
    Pagination
  },

  data() {
    return {
      text: "",
      pagination: [],
      receipts: []
    };
  },


  computed: {
    // ...mapGetters({
    //   receipts: "receipts",
    // }),
  },

  mounted() {
    // this.$store.dispatch("getReceipts")
    this.getCodes(1)
  },

  methods: {
    getCodes(pagination) {
      if (pagination) {
        axios.get('codes?per_page=10&page=' + pagination + '', {
          headers: {
            'Accept': "application/json",
            'Content-Type': "application/json",
            'access-control-allow-origin': "*",
            'Authorization': "Bearer " + localStorage.getItem('token-bockarev')
          }
        }).then((response) => {
            if (!this.pagination.length) {
              for (let i = 0 ; i < response.data.meta.lastPage; i++) {
                this.pagination.push(i + 1)
              }
            }
            this.receipts = response.data.data
        })
      } else {
        axios.get('codes?per_page=10&page=1', {
          headers: {
            'Accept': "application/json",
            'Content-Type': "application/json",
            'access-control-allow-origin': "*",
            'Authorization': "Bearer " + localStorage.getItem('token-bockarev')
          }
        }).then((response) => {
            this.receipts = response.data.data
        })
      }
    },

    openPrizesModal(slug) {
      if (slug === "weekly") {
        this.$bvModal.show('weekly-prizes-modal')
      } else if (slug === "monthly") {
        this.$bvModal.show('monthly-prizes-modal')
      }
    },

    toggleSubTable(id) {
      const area = event.target.classList.contains('plus-wrapper') ? event.target :
                  event.target.parentElement

      const icon = area.querySelector('.active-icon')
      icon.classList.remove('active-icon')

      if (icon.classList.contains('plus')) {
        const minus = area.querySelector('.minus')
        minus.classList.add('active-icon')
      } else {
        const plus = area.querySelector('.plus')
        plus.classList.add('active-icon')
      }

      const prizesEl = document.getElementById(`${id}`)

      if (prizesEl.classList.contains('hidden')) {
        prizesEl.classList.remove('hidden')
      } else {
        prizesEl.classList.add('hidden')
      }

      prizesEl.scrollIntoView({behavior: 'smooth', block: "nearest"})
    },

    pageChange(pageNumber) {
      this.getCodes(pageNumber)
    },

    openBookModal(index) {
      this.$bvModal.show('book-modal'+index)
    },

    openIviModal(index) {
      this.$bvModal.show('ivi-modal'+index)
    },

    openCommonModal(index) {
      this.$bvModal.show('cert-modal'+index)
    },

    getText(value) {
      this.text = value;
    },
  },
};
</script>

<style scoped lang="scss">
.table-wrapper {
  margin-top: 30px;
  width: 100%;
  margin-bottom: 35px;
}

.green-subtable {
  background-color: $green;
}

.table-header {
  width: 100%;
  margin-bottom: 0px;
  padding: 0 45px;
  text-align: center;
  line-height: 106%;
  background-color: $green;
  color: white;
  padding: 11px 15px;
  border-radius: 55px;
  height: 57px;
  margin-top: -3px;

  @media (max-width: 768px) {
    margin: 0;
    margin-bottom: 15px;
    padding: 0 15px;
  }

  &__green {
    border-radius: 0;
    border-bottom: 1px solid #F0DEDC;
    margin-left: 0 !important;
    margin-right: 0 !important;
    text-align: left;
    padding-left: 45px;

    div {
      justify-content: flex-start !important;
    }

    @media(max-width: 576px) {
      padding-left: 15px;
    }
  }

  div {
    width: 25%;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
      width: 50%;
      font-size: 14px;
    }
  }
}

.table-line {
  text-align: center;
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #1c5630;
  padding-left: 45px;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    margin: 0;
    padding: 15px;
  }

  &__green {
    background-color: $green;
    color: white;
    border-bottom: 1px solid #F0DEDC;
    margin-left: 0 !important;
    margin-right: 0 !important;
    text-align: left;
  }

  div {
    width: 25%;
    font-size: 18px;

    &:nth-child(2) {
    }

    &:nth-child(3) {
      @media (max-width: 999px) {
        padding-right: 0;
      }
    }

    &:nth-child(4) {
      @media (max-width: 999px) {
        padding-left: 0;
      }
    }

    @media (max-width: 768px) {
      width: 50%;
      font-size: 14px;
    }
  }
}

.flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    line-height: 110%;
}

.period-wrapper {
  position: relative;
  display: flex;
  justify-content: flex-start;
}

.period-hint {
}

.tooltip {
  opacity: 1;
  cursor: pointer;
  transition: .6s all;
  margin-left: 4px;
  margin-top: -5px;
  z-index: 2;

  &:hover {
    opacity: .7;
  }

  @media(max-width: 720px) {
    top: 0;
    left: 90px;
  }
}

.table {
  max-height: 500px;
  overflow-y: scroll;
  padding: 0;
  background-color: $white;
  border-radius: 25px;
  box-shadow: 0px 7px 20px 7px rgba(103, 103, 103, 0.1);
  // scrollbar-width: none;
  width: 100%;
  scrollbar-width: thin !important;
  scrollbar-color: $green #f1f1f1;

  ::webkit-scrollbar {
    width: thin !important;
    scrollbar-width: thin !important;
    scrollbar-color: $green #f1f1f1 !important;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 40px !important;
  }

  @media (max-width: 768px) {
    padding: 0px;
    max-height: 300px;
  }
}

h3 {
  font-weight: 700;
  font-size: 22px;
  margin: 15px;
}

.dekstop-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border: 2px solid #1c5630;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-bottom: none;

  @media (max-width: 768px) {
    display: none;
  }
}

.mobile-table {
  display: none;
  width: 100%;

  @media (max-width: 768px) {
    display: block;
  }
}

.plus-wrapper {
  width: 35px;
  height: 35px;
  right: 0;
  position: absolute;
  top: -5px;
  cursor: pointer;
}

.icon {
  position: absolute;
  cursor: pointer;
  display: none;
  transition: 0.8s all;
  right: 10px;
  top: 10px;

  &:hover {
    opacity: 0.7;
  }

  @media(max-widht: 576px) {
    top: 50%;
  }
}

.minus {
  top: 19px;
}

.active-icon {
  display: block !important;
}

.hidden {
  display: none;
}

.header {
  padding-top: 70px;
}

.download-icon {
  margin-left: 10px;
  cursor: pointer;
  transition: .6s all;
  max-width: 100%;

  &:hover {
    opacity: .7;
  }

  @media(max-width: 576px) {
    margin-right: 10px;
  }
}

.button-modal {
  width: 100%;
  max-width: 355px;
  height: 64px;
  color: white !important;
  margin-bottom: 50px;
  font-size: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: transparent;
  transition: 0.4s all;
  background-image: url("@/assets/button-bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  font-weight: 600;
  outline: none !important;
  box-shadow: none !important;
  border: none !important;

  &:hover {
    background-color: transparent;
    opacity: 0.6;
    transition: 0.4s all;
    text-decoration: none !important;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  @media (max-width: 1044px) {
    font-size: 20px !important;
  }

  @media (max-width: 999px) {
    font-size: 18px !important;
    height: 50px;
  }

  @media (max-width: 576px) {
    max-width: 290px;
    font-size: 14px !important;
  }
}

.prize-name-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px;

  @media(max-width: 768px) {
    padding-right: 12px;
  }
}

.center-j {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
